import React, { useState, useEffect, useMemo } from "react";
import { SelectOption } from "../../input/SearchInput/types";
import { HgRegion } from "../../../types/taxonomy";
import { SearchInput } from "../../input/SearchInput/SearchInput";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import { LOCATION_MESSAGES } from "./constants";

interface RegionInputProps {
  selectedItems: string[];
  onRegionSelect: (regionIds: string[]) => void;
}

const convertToRegionOptions = (regions: HgRegion[]): SelectOption[] =>
  regions.map((region) => ({ label: region.name, value: region.name }));

export const RegionInput: React.FC<RegionInputProps> = ({
  selectedItems = [],
  onRegionSelect,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<SelectOption[]>([]);
  const { regions } = useTaxonomyContext();

  const allOptions = useMemo(
    () => convertToRegionOptions(regions as HgRegion[]),
    [regions]
  );

  useEffect(() => {
    if (allOptions.length > 0) {
      const initialSelectedOptions = allOptions.filter((option) =>
        selectedItems.includes(option.value)
      );
      setSelectedOptions(initialSelectedOptions);
    }
  }, [selectedItems, allOptions]);

  const handleOptionsSelect = (options: SelectOption[]) => {
    setSelectedOptions(options);
    onRegionSelect(options.map((option) => option.value));
  };

  return (
    <SearchInput
      id="regions"
      options={allOptions}
      selectedOptions={selectedOptions}
      onOptionsSelect={handleOptionsSelect}
      placeholderText={LOCATION_MESSAGES.REGION.PLACEHOLDER}
      noResultsMessage={LOCATION_MESSAGES.REGION.NO_RESULTS}
      minFilterLength={0}
    />
  );
};
